/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { Payouts } from 'store/Collections';
import { TipCalculator } from 'store/TipCalculator';
import { IEmployee } from 'types';
import { Employee } from './types';

const initialState: IEmployee | null = null;

export const employeeReducer: Reducer<IEmployee | null> = (state = initialState, action) => {
  switch (action.type) {
    case Payouts.GET_SITE_EMPLOYEE_PAYOUTS_SUCCESS: {
      return action.payload.employee;
    }
    case Employee.ADD_EMPLOYEE_TO_SITE_SUCCESS:
    case Employee.REMOVE_EMPLOYEE_FROM_SITE_SUCCESS:
    case Employee.UPDATE_EMPLOYEE_SITE_ROLE_SUCCESS:
    case Employee.UPDATE_EMPLOYEE_SUCCESS:
    case TipCalculator.UNLINK_EMPLOYEE_SUCCESS:
    case Employee.GET_EMPLOYEE_SUCCESS: {
      return {
        ...action.payload,
        ...(state?.user?.cardDetail &&
          state.user.id === action.payload.user?.id && {
            user: {
              ...action.payload.user,
              cardDetail: state.user.cardDetail,
            },
          }),
      };
    }
    case Employee.GET_EMPLOYEE_CARD_REQUEST: {
      return {
        ...state,
        ...(state?.user && {
          user: {
            ...state.user,
            cardDetail: undefined,
          },
        }),
      };
    }
    case Employee.GET_EMPLOYEE_CARD_SUCCESS: {
      return {
        ...state,
        user: {
          ...state?.user,
          cardDetail: action.payload,
        },
      };
    }
    default: {
      return state;
    }
  }
};
